import api from '@/security/api'
import querystring from 'querystring'
import errorCatch from '@/helpers/errorCatch'

require('./../../security/interceptors')

const findAll = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.get(`/contactscoming?${query}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar a listagem de grupos')
        })
}

const store = (data) => {
    let formData = new FormData()

    if (data.group_id) {
        formData.append('group_Id', data.group_id)
    }
    if (data.client_id) {
        formData.append('client_Id', data.client_id)
    }
    formData.append('group_name', data.group_name || '')
    formData.append('description', data.description || '')
    formData.append('status', 0)
    formData.append('send_On_Finish', true)
    formData.append('export_Invalids', true)
    if (data.file) {
        formData.append('file', data.file)
    }
    formData.append('manual_List', data.load_text || '')
    formData.append('valid_Contacts', 0)
    formData.append('inValid_Contacts', 0)
    formData.append('total_Contacts', 0)

    return api.post('/contactscoming', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível salvar o grupo')
        })
}

const storeVars = (data) => {
    let formData = new FormData()

    formData.append('file', data.file)
    if (data.id_companies) {
        formData.append('id_companies', data.id_companies)
    }

    return api.post('/contacts-vars', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível enviar o arquivo para importação')
        })
}

export default {
    findAll,
    store,
    storeVars
}
